var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true,
      "fluid": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('m-header', {
          attrs: {
            "title": _vm.$t('common.nouns.report'),
            "breadCrumbs": _vm.breadCrumbs,
            "chips": _vm.chips,
            "actions": _vm.actions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        }), _c('fleet-manager-tree-dialog', {
          ref: "dialog",
          on: {
            "confirm": _vm.debounceUpdateTable
          }
        }), _vm.fleetId ? _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12"
          }
        }, [_c('paginated-table', {
          key: _vm.updateTableKey,
          ref: "reportTable",
          attrs: {
            "store": _vm.store,
            "headers": _vm.headers,
            "baseQuery": {
              partnerId: _vm.partnerId,
              fleetId: _vm.fleetId
            },
            "predefinedFilter": _vm.predefinedFilter,
            "showSelect": false,
            "isDownloadAsDisplayed": true,
            "downloadConfig": _vm.reportDownloadConfig
          },
          on: {
            "click:row": _vm.openDetail
          },
          scopedSlots: _vm._u([{
            key: "item.timestamp.created",
            fn: function fn(_ref) {
              var item = _ref.item;
              return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
            }
          }, {
            key: "item.status",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_c('v-chip', {
                attrs: {
                  "x-small": ""
                }
              }, [_vm._v(" " + _vm._s(item.status))])];
            }
          }, {
            key: "item.accidentDetails.date",
            fn: function fn(_ref3) {
              var _item$accidentDetails, _item$workShopCompany, _item$workShopCompany2, _item$repair, _item$repair2, _item$repair3;

              var item = _ref3.item;
              return [_c('span', {
                staticClass: "font-weight-black mr-1 mt-1"
              }, [_vm._v(_vm._s(item.numberplate))]), item.companyName ? _c('v-chip', {
                staticClass: "mr-1",
                attrs: {
                  "x-small": "",
                  "outlined": ""
                }
              }, [_vm._v(_vm._s(item.companyName))]) : _vm._e(), item.fleet.title ? _c('v-chip', {
                staticClass: "mr-1",
                attrs: {
                  "x-small": "",
                  "outlined": ""
                }
              }, [_vm._v(_vm._s(item.fleet.title))]) : _vm._e(), item.costCenter ? _c('v-chip', {
                staticClass: "mr-1",
                attrs: {
                  "x-small": "",
                  "outlined": ""
                }
              }, [_vm._v(_vm._s(item.costCenter))]) : _vm._e(), _c('div', [_vm._v(" #" + _vm._s(item.claimNumber) + " "), item.customerName ? _c('span', [_c('b', [_vm._v("·")]), _vm._v(" " + _vm._s(item.customerName))]) : _vm._e(), _c('div', {
                staticClass: "my-1"
              }, [(_item$accidentDetails = item.accidentDetails) !== null && _item$accidentDetails !== void 0 && _item$accidentDetails.date ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-calendar-month-outline ")]), _c('span', [_vm._v(_vm._s(_vm._f("dottedDateWithDayAndDer")(item.accidentDetails.date)) + " ")])], 1) : _vm._e(), item.coverageType ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-shield-car ")]), _c('span', [_vm._v(_vm._s(_vm.$t("enums.CoverageTypeEnum.".concat(item.coverageType))) + " ")])], 1) : _vm._e(), item.damageType ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-alert-decagram-outline ")]), _c('span', [_vm._v(_vm._s(_vm.$t("enums.DamageTypeEnum.".concat(item.damageType))))])], 1) : _vm._e(), item.tripType ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-map-marker-path ")]), _c('span', [_vm._v(_vm._s(_vm.$t("enums.TripTypeEnum.".concat(item.tripType))))])], 1) : _vm._e(), item !== null && item !== void 0 && (_item$workShopCompany = item.workShopCompany) !== null && _item$workShopCompany !== void 0 && _item$workShopCompany.company ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-garage-variant ")]), _c('span', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$workShopCompany2 = item.workShopCompany) === null || _item$workShopCompany2 === void 0 ? void 0 : _item$workShopCompany2.company) + " ")])], 1) : _vm._e(), item !== null && item !== void 0 && (_item$repair = item.repair) !== null && _item$repair !== void 0 && _item$repair.status ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-progress-wrench ")]), _c('span', [_vm._v(_vm._s(_vm.$t("enums.RepairStatusEnum.".concat(item.repair.status))) + " ")])], 1) : _vm._e(), item !== null && item !== void 0 && (_item$repair2 = item.repair) !== null && _item$repair2 !== void 0 && _item$repair2.startDate ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-calendar-arrow-right ")]), _c('span', [_vm._v(_vm._s(_vm._f("simpleDoubleDigitDate")(item.repair.startDate)) + " ")])], 1) : _vm._e(), item !== null && item !== void 0 && (_item$repair3 = item.repair) !== null && _item$repair3 !== void 0 && _item$repair3.endDate ? _c('small', {
                staticClass: "mr-1",
                attrs: {
                  "label": "",
                  "outlined": ""
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": "grey"
                }
              }, [_vm._v(" mdi-calendar-arrow-left ")]), _c('span', [_vm._v(_vm._s(_vm._f("simpleDoubleDigitDate")(item.repair.endDate)) + " ")])], 1) : _vm._e()])])];
            }
          }, {
            key: "item.invoiceInboundAggregation.totals",
            fn: function fn(_ref4) {
              var item = _ref4.item,
                  value = _ref4.value;
              return [value ? _c('div', {
                staticClass: "font-weight-black"
              }, _vm._l(value.split(', '), function (v, index) {
                return _c('div', {
                  key: 'totals' + item.id + index
                }, [_vm._v(" " + _vm._s(v) + " ")]);
              }), 0) : _c('span', {
                staticClass: "font-weight-black",
                staticStyle: {
                  "text-align": "right"
                }
              }, [_vm._v("-")])];
            }
          }, {
            key: "item.invoiceSelfContributionAggregation.totals",
            fn: function fn(_ref5) {
              var item = _ref5.item;
              return [item.invoiceSelfContributionAggregation && item.invoiceSelfContributionAggregation.totals && item.invoiceSelfContributionAggregation.totals.length > 0 ? _c('div', {
                staticClass: "font-weight-black"
              }, _vm._l(item.invoiceSelfContributionAggregation.totals, function (total) {
                return _c('div', {
                  key: "invoice_aggregation_self_contribution_".concat(item.id, "_").concat(total.currency)
                }, [_vm._v(" " + _vm._s(_vm.formatCurrency(total.subtotal, total.currency)) + " ")]);
              }), 0) : _c('span', {
                staticStyle: {
                  "text-align": "right"
                }
              }, [_vm._v("-")])];
            }
          }], null, false, 1819562340)
        })], 1)], 1) : _c('v-row', [_c('v-col', [_c('error-card', {
          on: {
            "reload": function reload($event) {
              return _vm.$router.push({
                name: 'FleetAnalyticsView'
              });
            }
          }
        })], 1)], 1), _vm.selectedId && _vm.currentReport ? _c('my-damage-detail-side-card', {
          attrs: {
            "loading": _vm.loading,
            "report": _vm.currentReport
          },
          on: {
            "close": function close($event) {
              _vm.selectedId = null;
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }